import React from "react";
import { Link } from "react-router-dom";

const LOGO_FULL = "https://customer-assets-0z36b82j.emergentagent.net/job_italian-biocare-dev/artifacts/jfsiztzq_BIONUTRIX%20COLORE%20FONT%20%281%29.png";
const LOGO_MARK = "https://customer-assets-0z36b82j.emergentagent.net/job_italian-biocare-dev/artifacts/hrasgpfd_BIONUTRIX%20MATERIAL%20COLORE.png";

export function Logo({ variant = "dark", size = 36, className = "" }) {
  const filter = variant === "light" ? "brightness(0) invert(1)" : "none";
  return (
    <Link
      to="/"
      data-testid="nav-logo"
      aria-label="BioNutrix — Home"
      className={`inline-flex items-center gap-2.5 ${className}`}
    >
      <img
        src={LOGO_MARK}
        alt=""
        aria-hidden="true"
        style={{ height: size, width: size, filter: variant === "light" ? "none" : "none" }}
        className="shrink-0 object-contain"
      />
      <span
        className={`font-body text-[15px] tracking-[0.28em] uppercase leading-none ${
          variant === "light" ? "text-[#F9F8F6]" : "text-[#1A2224]"
        }`}
      >
        BioNutrix
      </span>
    </Link>
  );
}

export function LogoMark({ size = 26, className = "" }) {
  return (
    <img
      src={LOGO_MARK}
      alt="BioNutrix"
      style={{ height: size, width: size }}
      className={`object-contain ${className}`}
    />
  );
}

export function LogoFull({ height = 60, variant = "dark", className = "" }) {
  return (
    <img
      src={LOGO_FULL}
      alt="BioNutrix"
      style={{ height, filter: variant === "light" ? "brightness(0) invert(1)" : "none" }}
      className={`object-contain ${className}`}
    />
  );
}

export default Logo;
